// Generated by scripts/import-seo-content.js — do not edit by hand.
// Regenerate with: node scripts/import-seo-content.js
import ContentSV, { meta as metaSV } from '@/content/seo/sv/falgar/transportbil/mercedes-sprinter.mdx'
import ContentEN, { meta as metaEN } from '@/content/seo/en/rims/van/mercedes-sprinter.mdx'
import { seoRoute } from '@/lib/seo/seoRoute'
import { makeSeoStaticProps } from '@/lib/seo/seoStaticProps'

const byLocale = {
  sv: { meta: metaSV, Content: ContentSV },
  en: { meta: metaEN, Content: ContentEN },
}

export const getStaticProps = makeSeoStaticProps(byLocale)

export default seoRoute(byLocale)
